module.exports = __webpack_public_path__ + "static/assets/f66ff00b75aca4eee3efa563c453760f.svg";